<template>
  <transition v-if="selector.active" name="modal">
    <v-row justify="center" align="center">
      <v-col>
        <div v-show="selector.active" :class="show_class()">
          <v-icon
            v-if="btn"
            v-ripple
            class="close-modal-btn"
            @click="selector.active = false"
          >
            mdi-window-close
          </v-icon>
          <v-container class="mt-0">
            <v-row
              v-if="selector.multiple"
              :class="selector.multiple ? 'mb-3 mt-6' : ''"
              justify="center"
              align="center"
            >
              <v-btn color="green" dark class="ma-2" @click="done()">
                <b>{{
                  selector.chat
                    ? $t("global_selector.send")
                    : $t("global_selector.done")
                }}</b>
              </v-btn>
              <v-btn
                :color="!selector.selectedIndexes.length ? '#c54141' : 'red'"
                class="ma-2"
                :class="selector.chat ? '' : 'white--text'"
                :dark="selector.chat ? true : false"
                :disabled="!selector.selectedIndexes.length"
                @click="clear()"
              >
                <b>{{ $t("global_selector.deselect") }}</b>
                <v-icon right size="19"> mdi-delete-alert </v-icon>
              </v-btn>
            </v-row>

            <v-container style="max-width: 1280px">
              <!-- filters -->
              <v-row
                :class="selector.multiple ? 'mb-3' : 'mt-6'"
                justify="center"
                no-gutters
              >
                <v-col cols="10" sm="4" lg="3" v-if="categories.length > 1">
                  <v-combobox
                    v-model="category"
                    :items="categories"
                    :label="$t('global_selector.category')"
                    class="selector"
                    solo
                    clearable
                    @change="(page = 1), (lengthPages = 0)"
                  >
                    <template #item="{ item }">
                      {{ item === "" ? $t("global_selector.all") : item }}
                    </template>
                  </v-combobox>
                </v-col>
                <v-col v-if="brands.length > 1" cols="10" sm="4" lg="3">
                  <v-combobox
                    v-if="brands.length"
                    v-model="brand"
                    :items="brands"
                    :label="$t('global_selector.brand')"
                    class="selector"
                    solo
                    clearable
                    @change="(page = 1), (lengthPages = 0)"
                  >
                    <template #item="{ item }">
                      {{ item === "" ? $t("global_selector.all") : item }}
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="10" sm="4" lg="3" v-if="colors.length > 1">
                  <v-combobox
                    v-model="color"
                    :items="colors"
                    :label="$t('global_selector.color')"
                    class="selector"
                    solo
                    clearable
                    @change="(page = 1), (lengthPages = 0)"
                  >
                    <template #item="{ item }">
                      {{ item === "" ? $t("global_selector.all") : item }}
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="10" sm="4" lg="3" v-if="materials.length > 1">
                  <v-combobox
                    v-model="material"
                    :items="materials"
                    :label="$t('global_selector.material')"
                    class="selector"
                    solo
                    clearable
                    @change="(page = 1), (lengthPages = 0)"
                  >
                    <template #item="{ item }">
                      {{ item === "" ? $t("global_selector.all") : item }}
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="10" sm="4" lg="3" v-if="sizes.length > 1">
                  <v-combobox
                    v-model="size"
                    :items="sizes"
                    :label="$t('global_selector.size')"
                    class="selector"
                    solo
                    clearable
                    @change="(page = 1), (lengthPages = 0)"
                  >
                    <template #item="{ item }">
                      {{ item === "" ? $t("global_selector.all") : item }}
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="10" sm="4" lg="3">
                  <v-combobox
                    v-model="on_sale"
                    :items="this.$store.state.product.OnSaleVals"
                    :label="$t(`global_selector.sale`)"
                    class="selector"
                    solo
                    clearable
                    @change="(page = 1), (lengthPages = 0)"
                  >
                    <template #item="{ item }">
                      {{
                        item === ""
                          ? $t("global_selector.all")
                          : $t(`global_selector.${item}`)
                      }}
                    </template>
                  </v-combobox>
                </v-col>
                <v-col v-if="genders.length > 2" cols="10" sm="4" lg="3">
                  <v-combobox
                    v-if="genders.length"
                    v-model="gender"
                    :items="genders"
                    :label="$t('global_selector.gender')"
                    class="selector"
                    solo
                    clearable
                    @change="(page = 1), (lengthPages = 0)"
                  >
                    <template #item="{ item }">
                      {{ item === "" ? $t("global_selector.all") : item }}
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
              <!-- /filters -->
              <v-row
                v-if="products_key.length"
                :class="selector.multiple ? 'mb-3' : 'mb-12'"
                justify="center"
                no-gutters
              >
                <v-col cols="4" sm="1" lg="1">
                  <v-combobox
                    v-model="perpage"
                    append-icon=""
                    class="ma-2"
                    :items="per_pages"
                    label="per-page"
                    solo
                    @change="MinValidePagination(perpage)"
                  />
                </v-col>
                <v-col cols="auto" sm="auto" class="pt-3">
                  <v-pagination
                    v-model="page"
                    :items="products_key"
                    :length="lengthPages"
                    :total-visible="7"
                    circle
                  />
                </v-col>
              </v-row>
              <v-row v-if="products_key.length">
                <v-col
                  v-for="(product, key) in articles"
                  :key="key"
                  cols="6"
                  sm="4"
                  md="3"
                  lg="3"
                  xl="3"
                >
                  <!--v-icon class="check" v-if="isSelected(product.product_id)">
              mdi-checkbox-marked-circle
                  </v-icon-->
                  <product-card
                    class="selectable"
                    :product="product"
                    :select_ids="selector.selectedIndexes"
                    :class="imageCss(product.product_id)"
                    :chips="product.custom[selector.selected_value]"
                    :selector="true"
                    @click="
                      selector.multiple
                        ? onImageSelect(product.product_id, product)
                        : selectProduct(product)
                    "
                  />
                </v-col>
              </v-row>
              <v-row v-else justify="center" align="center">
                <v-col cols="auto" class="mt-12">
                  <h3 class="white--text">No products mutch this filters</h3>
                </v-col>
              </v-row>
              <v-row class="mb-12" justify="center" v-if="products_key.length">
                <div class="text-center">
                  <v-pagination
                    v-show="!$store.state.isMobile"
                    v-model="page"
                    :items="products_key"
                    :length="lengthPages"
                    :total-visible="7"
                    circle
                  />
                </div>
              </v-row>
            </v-container>
          </v-container>
        </div>
      </v-col>
    </v-row>
  </transition>
</template>

<script>
export default {
  name: "Selector",
  data: () => ({
    category: undefined,
    brand: undefined,
    color: undefined,
    material: undefined,
    size: undefined,
    on_sale: undefined,
    gender: undefined,
    selected: undefined,
    total: 0,
    page: 1,
    perpage: 32,
    per_pages: ["32", "52", "92"],
    lengthPages: 0,
    articles: [],
    btn: false,
    chat_looks: [],
  }),
  computed: {
    selector() {
      return this.$store.state.selector;
    },
    products_key: {
      get: function () {
        const product = this.$store.getters.filterProducts(
          this.category,
          this.brand,
          this.color,
          this.gender,
          this.material,
          this.size,
          this.on_sale
        );
        //to avoid side effects of products_key in computed
        this.init(product);
        // console.log(product);
        ///////////////////////////////////
        return product;
      },
    },
    categories: {
      get: function () {
        return this.sort_alpha(this.$store.state.product.categories);
      },
    },
    brands: {
      get: function () {
        return this.sort_alpha(this.$store.state.product.brands);
      },
    },
    colors: {
      get: function () {
        return this.sort_alpha(this.$store.state.product.colors);
      },
    },
    materials: {
      get: function () {
        return this.sort_alpha(this.$store.state.product.materials);
      },
    },
    genders: {
      get: function () {
        return this.sort_alpha(this.$store.state.product.gender);
      },
    },
    sizes: {
      get: function () {
        const data = this.$store.state.product.sizes;
        const sortAlphaNum = (a, b) =>
          a.localeCompare(b, "en", { numeric: true });
        return data.sort(sortAlphaNum);
      },
    },
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        if (this.btn) this.selector.active = false;
      }
    });
  },
  methods: {
    sort_alpha(array) {
      return array.sort();
    },
    init(product) {
      this.total = Object.values(product).length;
      this.articles = this.pagenated(product);
      if (!this.category) this.category = undefined;
      if (!this.brand) this.brand = undefined;
      if (!this.color) this.color = undefined;
    },
    show_class() {
      // console.log("selector", this.$store.state.selector);
      if (
        this.$store.state.selector.chat &&
        this.$store.state.selector.multiple
      ) {
        this.btn = true;
        return "modal-mask scroll";
      } else if (
        !this.$store.state.selector.chat &&
        this.$store.state.selector.multiple
      ) {
        this.btn = false;
        return "modal-mask-multiple";
      } else {
        this.btn = true;
        return "modal-mask scroll";
      }
    },
    pagenated(product) {
      const page = this.page;
      const perpage = this.perpage;
      const from = page * perpage - perpage;
      const to = page * perpage;
      this.lengthPages = Math.ceil(this.total / this.perpage);
      const res = Object.keys(product)
        .slice(from, to)
        .reduce((result, key) => {
          result[key] = product[key];
          return result;
        }, {});
      // console.log("res", res, this.lengthPages);
      return res;
    },
    MinValidePagination(page) {
      // console.log("is int");
      if (isNaN(page)) {
        this.$store.dispatch("setSnackbar", {
          text: `" ${page} " Is not a Number`,
          color: "warning",
        });
        this.perpage = 10;
      }
      if (page < 10) {
        this.$store.dispatch("setSnackbar", {
          text: "The minimum perpage to display is 10",
          color: "warning",
        });
        this.perpage = 10;
      }
    },
    done() {
      /// /console.log(this.selector.products);
      if (this.selector.chat) {
        this.selector.products.forEach((element) => {
          if (element.selected) {
            this.chat_looks = this.chat_looks.concat(element);
          }
        });
        this.selector.resolve(this.chat_looks);
        this.chat_looks = [];
      } else this.selector.resolve(this.selector.products);
      this.$store.commit("selector/DEACTIVATE");
    },
    clear() {
      if (this.selector.chat) {
        this.selector.selectedIndexes = [];
        Object.values(this.selector.products).forEach((element) => {
          element.selected = false;
        });
        this.chat_looks = [];
      } else {
        this.$store
          .dispatch("confirmer/ask", {
            title: this.$t("show_box.title"),
            body: this.$t("show_box.agree"),
          })
          .then((confirmation) => {
            if (confirmation) {
              this.selector.selectedIndexes = [];
              Object.values(this.selector.products).forEach((element) => {
                element.selected = false;
              });
              this.$store.dispatch("setSnackbar", {
                text: "Products deselected",
                color: "success",
              });
            }
          });
      }
    },
    selectProduct(product) {
      this.selector.resolve(product);
      this.$store.commit("selector/DEACTIVATE");
    },
    isSelected(index) {
      /** check the index passed in param if icludes in the item array and return (true | false) */
      if (this.selector.multiple) {
        return this.selector.selectedIndexes.includes(index);
      }
    },
    imageCss(imageIndex) {
      /** add active class to the item selected */
      const classes = [""];
      this.check_icon = false;
      if (this.isSelected(imageIndex)) {
        // Add "active" if selected
        classes.push("active");
        this.check_icon = true;
      }
      return classes;
    },
    onImageSelect(imageIndex, product) {
      if (this.isSelected(imageIndex)) {
        // Leave only the selected image “other than”
        this.selector.selectedIndexes = this.selector.selectedIndexes.filter(
          (selectedIndex) => {
            return selectedIndex !== imageIndex;
          }
        );
        var removeIndex = this.selector.products
          .map(function (item) {
            return item.prod_data.product_id;
          })
          .indexOf(imageIndex);
        // console.log(removeIndex);
        this.selector.products[removeIndex].selected = false;
      } else {
        this.selector.selectedIndexes.push(imageIndex);
        var Add = this.selector.products
          .map(function (item) {
            return item.prod_data.product_id;
          })
          .indexOf(imageIndex);
        // console.log(Add);
        if (Add == -1) {
          this.selector.products.push({ prod_data: product, selected: true });
        } else this.selector.products[Add].selected = true;
      }
      /// /console.log("All", this.selector.products);
    },
  },
};
</script>

<style scoped>
.selectable:hover {
  border: 2px solid #ccc;
  cursor: pointer;
}

.selector {
  padding: 8px;
}
.scroll {
  overflow: hidden scroll !important;
  scroll-behavior: smooth;
  height: 446px !important;
}
.scroll::-webkit-scrollbar {
  width: 13px;
  height: 15%; /* width of the entire scrollbar */
}
.scroll::-webkit-scrollbar-track {
  background: #80808038;
  border-radius: 20px; /* color of the tracking area */
}
.scroll::-webkit-scrollbar-thumb {
  background-color: #1a4dcd; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 1px solid grey; /* creates padding around scroll thumb */
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  width: calc(100% - 79px);
  min-height: 100%;
  background-color: rgba(0, 0, 0, 0.79);
  transition: opacity 0.3s ease;
}

@media only screen and (max-width: 1261px) {
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    width: 100%;
    min-height: 100%;
    background-color: rgba(0, 0, 0, 0.79);
    transition: opacity 0.3s ease;
  }
}

@media only screen and (max-width: 700px) {
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    width: 100%;
    min-height: 100%;
    background-color: rgba(0, 0, 0, 0.79);
    transition: opacity 0.3s ease;
  }
  .scroll::-webkit-scrollbar {
    width: 18px;
    height: 15%; /* width of the entire scrollbar */
  }
}
.modal-mask-multiple {
  margin-top: -37px;
  -webkit-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
  overflow: auto;
}
.close-modal-btn {
  color: white;
  font-size: 43px;
  padding: 4px;
  border-radius: 50%;
  right: 4%;
  top: 22px;
  position: fixed;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.2);
}
.close-modal-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}
.modifiable:hover {
  border: 2px solid #ccc;
  cursor: pointer;
  border-radius: 2px !important;
}
.active {
  cursor: pointer;
  display: block;
  opacity: 0.81;
}
.check {
  color: #06da5c;
  position: absolute;
  font-size: 80px;
  padding: 7px;
}
.pages {
  left: 46px;
  position: absolute;
  width: 10%;
}
</style>
